<section>
  <h3 class="notification success p-m">Vereinbarung zu den Allgemeinen Retourenbedingungen (ARB)</h3>

  <div class="d-grid conditions-grid">
    <div>
      <p>
        <u>Rückgabefristen</u>
        <mat-icon class="info-icon material-symbols-outlined"
                  matTooltip="Arbeitstage (AT) von Mo - Fr; ausgenommen Feiertage">
          info
        </mat-icon>
      </p>
      <div class="d-grid deadline-grid">
        <strong class="text-right pt-xs">{{ conditions()?.returnDeadlineOrderError ?? 0 }}
          AT</strong>
        <span class="pt-xs">Rückgabefrist bei Bestellfehler</span>
        <strong class="text-right pt-xs">{{ conditions()?.returnDeadlineExpiry ?? 0 }}
          AT</strong>
        <span class="pt-xs pt-xs">Rückgabefrist bei Verfall (6 bis 12 Monate)</span>
        <strong class="text-right pt-xs">{{ conditions()?.returnDeadlineBtmCool ?? 0 }}
          AT</strong>
        <span pt-xs>Rückgabefrist BTM & Kühlartikel</span>
        <span class="grey-background columns-2 p-xs">Mängelrügen sind
          unverzüglich, jedoch spätestens binnen 7 AT zu melden.</span>
      </div>
    </div>
    <div>
      <p>
        <u>Mindestwert / Gebühren</u>
      </p>
      <div class="d-grid fees-grid">
        <strong class="text-right"> {{ ( conditions()?.fixedFeePerPacket ?? 0) | currency:'EUR':'symbol':'1.2-2' }}</strong>
        <span class="pt-xs">Fixgebühr pro Packung</span>
        <strong class="text-right pt-xs">{{ ( conditions()?.fixedFeeHighPrice ?? 0) | currency:'EUR':'symbol':'1.2-2' }} </strong>
        <span class="pt-xs">Fixgebühr für Hochpreisartikel</span>
        <strong class="text-right pt-xs">{{ ( conditions()?.minimumValueBtmCool ?? 0) | currency:'EUR':'symbol':'1.2-2' }}</strong>
        <span class="pt-xs">Mindestwert BTM & Kühlartikel</span>
        <strong class="text-right pt-xs">{{  conditions()?.processingFee ?? 0 }}
          %</strong>
        <span class="py-xs">Bearbeitungsgebühr für Warenrücknahme
          <mat-icon class="info-icon material-symbols-outlined"
                    matTooltip="Die Bearbeitungsgebühren fallen nach Überschreitung der Rückgabefrist für Bestellfehler an.">
            info
          </mat-icon>
        </span>
      </div>
    </div>
    <div class="d-flex flex-column aie jcc">
      <button mat-mini-fab color="primary" type="button" class="btn-download" (click)="savePdf()"><mat-icon fontSet="material-symbols-outlined" aria-hidden="false">download</mat-icon></button>
    </div>
  </div>
</section>
